import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Sun, Moon } from "lucide-react";
import { useTheme } from "@/contexts/ThemeContext";
import { useTranslation } from "react-i18next";
import { springs } from "@/lib/motion";

// Icon reflects the CURRENT mode: moon in dark, sun in light. A short text label
// ("Dark"/"Light") sits to the right; tapping the icon or the text toggles.
export const ThemeToggle = ({ className = "", showLabel = true }) => {
  const { theme, toggle } = useTheme();
  const { t } = useTranslation();
  const isDark = theme === "dark";
  return (
    <button
      onClick={toggle}
      aria-label={t("common.theme")}
      data-testid="theme-toggle"
      className={`flex items-center gap-2 px-2 py-2 rounded-full transition-colors hover:bg-[color:var(--bg-subtle)] ${className}`}
      style={{ color: "var(--text-primary)" }}
    >
      <motion.span
        key={theme}
        initial={{ rotate: -90, opacity: 0, scale: 0.6 }}
        animate={{ rotate: 0, opacity: 1, scale: 1 }}
        transition={springs.icon}
        style={{ display: "inline-flex" }}
      >
        {isDark ? <Moon className="w-5 h-5" /> : <Sun className="w-5 h-5" />}
      </motion.span>
      {showLabel && (
        <AnimatePresence mode="wait" initial={false}>
          <motion.span
            key={theme}
            initial={{ opacity: 0, y: 6 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -6 }}
            transition={{ duration: 0.18 }}
            className="text-sm font-medium"
            data-testid="theme-toggle-label"
          >
            {isDark ? t("common.dark") : t("common.light")}
          </motion.span>
        </AnimatePresence>
      )}
    </button>
  );
};
